var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.99593C13.9958 7.55719 13.8141 7.13772 13.4943 6.82842L9.81714 3.2425C9.65655 3.08718 9.4393 3 9.21286 3C8.98641 3 8.76917 3.08718 8.60857 3.2425C8.52823 3.32003 8.46447 3.41226 8.42095 3.51388C8.37743 3.61551 8.35503 3.72451 8.35503 3.8346C8.35503 3.94468 8.37743 4.05368 8.42095 4.15531C8.46447 4.25693 8.52823 4.34916 8.60857 4.42669L11.4286 7.16199H2.85714C2.62981 7.16199 2.4118 7.24985 2.25105 7.40625C2.09031 7.56264 2 7.77475 2 7.99593C2 8.2171 2.09031 8.42921 2.25105 8.58561C2.4118 8.742 2.62981 8.82986 2.85714 8.82986H11.4286L8.60857 11.5735C8.44717 11.7294 8.35604 11.9414 8.35524 12.1626C8.35443 12.3839 8.44402 12.5965 8.60429 12.7535C8.76455 12.9106 8.98237 12.9992 9.20983 13C9.43728 13.0008 9.65574 12.9136 9.81714 12.7577L13.4943 9.17177C13.8162 8.86042 13.9981 8.43756 14 7.99593Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrowSmall);
export default __webpack_public_path__ + "static/media/forwardArrowSmall.36e7d5df3a271222d6b961b29f695ca8.svg";
export { ForwardRef as ReactComponent };